import PropTypes from 'prop-types';
import { PureComponent } from 'react';

import CmsBlock from 'Component/CmsBlock';

import { promotions_top_block } from './PromotionsTopBlock.config';

/** @namespace Bodypwa/Component/PromotionsTopBlock/Component */
export class PromotionsTopBlockComponent extends PureComponent {
    static propTypes = {
        isCheckout: PropTypes.bool.isRequired,
        isHomePage: PropTypes.bool.isRequired,
        isSuccess: PropTypes.bool.isRequired
    };

    render() {
        const { isCheckout, isHomePage, isSuccess } = this.props;
        if (isCheckout || isHomePage || isSuccess) {
            return null;
        }

        return (
            <div block="PromotionsTopBlock">
                <CmsBlock identifier={ promotions_top_block } />
            </div>
        );
    }
}

export default PromotionsTopBlockComponent;
